import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import CheckpointsContainer from '../../DesignSystem/Checkpoints/Container';
import {Icon} from '../../DesignSystem/Checkpoints/CheckpointItem';
import {Locale} from '../../../RootProvider/LocaleContext';

import './Checkpoints.scss';

function Checkpoints(): ReactElement {
  const {formatMessage} = useIntl();
  const data = [
    {id: 1, content: formatMessage({id: 'homepage.checkpoints.1'})},
    {id: 2, content: formatMessage({id: 'homepage.checkpoints.2'})},
    {id: 3, content: formatMessage({id: 'homepage.checkpoints.3'})},
    {id: 4, content: formatMessage({id: 'homepage.checkpoints.4'}), locales: [Locale.uk]},
  ];

  return <CheckpointsContainer className="homepageCheckpoints" listItems={data} icon={Icon.TICKED_CIRCLE} />;
}

export default Checkpoints;
